export default  {	
	data () {
		return { 
			cardCol: 9,
			cardCol2: 3,
			cardHover: 1,
			editarDataPost: false,
			total: 0,
			active: 0,
			updates: 0,
			ultimaRazon: null,
			errorsAportes: null
		}
	},
	destroyed()
	{		
		this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required'})
	},
	async created () { 
		await this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required|minIngreso'})
		await this.onInit()
	},
	methods:{
		async onInit()
		{
			this.ultimaRazon=this.dataForm[this.namePath].info_afiliacion.id_datos_razon	
			const await0 = this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required'})
			const await1 = this.updateDataForm({state: 'afiliado_beneficiarios', data: []})
			const await2 =  this.updateDataForm({state: 'precios', data: await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1}) })
			const await3 =  this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })
			await Promise.all([await0,await1,await2,await3])
			
		}
	}
}
